import { useRef } from 'react';
import { Loader, Search, X } from 'lucide-react';
import type { ChangeEvent } from 'react';

interface SearchInputProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  placeholder?: string;
  isSearching?: boolean;
  className?: string;
}

function SearchInput({
  value,
  onChange,
  onClear,
  placeholder = 'Search...',
  isSearching = false,
  className = '',
}: SearchInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={`relative flex items-center ${className}`}>
      <Search size={16} className='ml-3 absolute left-[0px]' aria-hidden={true} />

      <input
        ref={inputRef}
        type='text'
        value={value}
        onChange={onChange}
        aria-label='Search input'
        aria-busy={isSearching}
        placeholder={placeholder}
        className='py-2 px-[36px] border border-gray-300 w-full focus:outline-[#7ad817] rounded-md text-sm'
      />

      {isSearching && (
        <Loader size={18} color='#7ad817' className='animate-spin absolute right-[10px]' aria-hidden={true} />
      )}

      {value && !isSearching && (
        <button
          onClick={onClear}
          className='right-[10px] absolute text-gray-500 hover:text-gray-700'
          aria-label='Clear search'
        >
          <X size={18} />
        </button>
      )}
    </div>
  );
}

export default SearchInput;
